import { t } from 'i18next';

import { CurrencyCodes } from '../../types/users/currency';

export function formatCurrency(amount: number, currency = CurrencyCodes.CAD, locale = 'en-US') {
  const hasCents = amount % 1 !== 0;
  const fractionDigits = hasCents ? 2 : 0;

  const result =
    amount > 0
      ? new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency ?? CurrencyCodes.CAD,
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        }).format(amount)
      : t('ticket.free');
  return result;
}
